import * as React from "react";
import * as _ from "underscore";

import { AppShape, HurdleShape, PropertyRepairShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import APIClient from "../../../APIClient";

import AppraisalRepairs from "./AppraisalRepairs";
import AppraisalSummary from "./AppraisalSummary";
import InspectionRepairs from "./InspectionRepairs";
import InspectionSummary from "./InspectionSummary";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

require(`../../../../assets/stylesheets/components/underwriter_dashboard/hurdle_editors/\
property_condition.scss`);

const { Button } = require("react-bootstrap");

interface PropertyConditionProps {
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

const modalTitle = "Property condition";

class PropertyCondition extends React.Component<PropertyConditionProps, any> {
  state = {
    repairs: null,
  };

  componentDidMount() {
    this.populateRepairs(this.props.app);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.app.id !== this.props.app.id) {
      this.populateRepairs(nextProps.app);
    }
  }

  static mergeExistingIntoAll(allRepairs, existingRepairs) {
    return _.map(allRepairs, (r: PropertyRepairShape) => {
      const existing: any = _.where(existingRepairs, {
        repair_type: r.repair_type,
      });
      if (existing.length > 0) {
        return {
          ...r,
          id: existing[0].id,
          in_appraisal: existing[0].in_appraisal,
          appraisal_cost_to_cure: existing[0].appraisal_cost_to_cure,
          appraisal_note: existing[0].appraisal_note,
          in_inspection: existing[0].in_inspection,
          inspection_cost_to_cure: existing[0].inspection_cost_to_cure,
          inspection_note: existing[0].inspection_note,
          seller_fix_description: existing[0].seller_fix_description,
          seller_fix_estimated_date: existing[0].seller_fix_estimated_date,
          seller_fix_reported_complete: existing[0].seller_fix_reported_complete,
          seller_fix_confirmed_complete: existing[0].seller_fix_confirmed_complete,
        };
      }
      return {
        ...r,
        id: null,
        in_appraisal: null,
        appraisal_cost_to_cure: null,
        appraisal_note: null,
        in_inspection: null,
        inspection_cost_to_cure: null,
        inspection_note: null,
        seller_fix_description: null,
        seller_fix_estimated_date: null,
        seller_fix_reported_complete: null,
        seller_fix_confirmed_complete: null,
      };
    });
  }

  populateRepairs(app) {
    const { id, property_repairs } = app;

    APIClient.get(`/loan_applications/${id}/hurdles/property_condition/possible_repairs`).then(
      (resp: any) => {
        this.setState({
          ...this.state,
          repairs: PropertyCondition.mergeExistingIntoAll(resp.possible_repairs, property_repairs),
        });
      },
    );
  }

  onChange(updatedRepairs) {
    this.setState({
      ...this.state,
      repairs: updatedRepairs,
    });
  }

  ineligibleRepairsInAppraisal() {
    const repairs = _.chain(this.state.repairs)
      .filter((r: PropertyRepairShape) => !r.eligible)
      .filter((r: PropertyRepairShape) => r.in_appraisal)
      .value();
    return repairs.length > 0;
  }

  ineligibleRepairsInInspection() {
    const repairs = _.chain(this.state.repairs)
      .filter((r: PropertyRepairShape) => !r.eligible)
      .filter((r: PropertyRepairShape) => r.in_inspection)
      .value();
    return repairs.length > 0;
  }

  renderModalWithContent(content) {
    const { app, hurdle, onHide } = this.props;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        {content}
        <footer className={styles.footer}>
          <Button bsSize="small" onClick={onHide}>
            <i className="fa fa-thumbs-up" /> OK
          </Button>
        </footer>
      </HurdleView>
    );
  }

  renderLoading() {
    return this.renderModalWithContent(<div>Loading…</div>);
  }

  render() {
    const {
      property_repairs_requested_inspection,
      property_repairs_will_supply_inspection,
      property_repairs_reviewed_inspection,
    } = this.props.app;

    if (!this.state.repairs) {
      return this.renderLoading();
    }

    const sharedProps = {
      ...this.props,
      modalTitle,
      repairs: this.state.repairs,
    };

    if (!property_repairs_requested_inspection) {
      return <AppraisalRepairs {...sharedProps} onChange={this.onChange.bind(this)} />;
    }
    if (!property_repairs_will_supply_inspection) {
      return <AppraisalSummary {...sharedProps} />;
    }
    if (
      property_repairs_will_supply_inspection &&
      (!property_repairs_reviewed_inspection || this.ineligibleRepairsInInspection())
    ) {
      return <InspectionRepairs {...sharedProps} onChange={this.onChange.bind(this)} />;
    }
    if (property_repairs_reviewed_inspection && !this.ineligibleRepairsInInspection()) {
      return <InspectionSummary {...sharedProps} />;
    }

    return this.renderModalWithContent(<div>not reached</div>);
  }
}

export default PropertyCondition;
